import axios from 'axios';
import { REACT_APP_API_URL } from '../env';

const BASE_URL = `${REACT_APP_API_URL}api/hrms`;

export const leaveRequestApi = {
  // Create a new leave request
  createLeaveRequest: async (leaveData) => {
    try {
      // leaveData must be FormData
      const response = await axios.post(
        `${BASE_URL}/create-leave-request`,
        leaveData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all leave requests for an employee
  getLeaveRequests: async (employeeId) => {
    try {
      const response = await axios.get(`${BASE_URL}/leave-requests/employee/${employeeId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get leave requests for the staff (manager)
  getStaffLeaveRequests: async (managerEmpCode) => {
    try {
      const response = await axios.get(`${BASE_URL}/leave/manager/${managerEmpCode}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }

  },

  // Get a specific leave request by ID
  getLeaveRequest: async (requestId) => {
    try {
      const response = await axios.get(`${BASE_URL}/leave-requests/${requestId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete a leave request
  deleteLeaveRequest: async (requestId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/delete-leave-request/${requestId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all leave requests (for admin/HR)
  getAllLeaveRequests: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      });

      const response = await axios.get(`${BASE_URL}/admin/leave-requests?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update leave request status (for admin) reject or approve
  updateLeaveRequestStatus: async (requestId, payload) => {
    try {
      const response = await axios.patch(
        `${BASE_URL}/admin/leave-requests/${requestId}/status`,
        {
          status: payload.status,
          managerRemarks: payload.managerRemarks || null
        }
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get Government holidays
  getGovtHolidays: async (fromDate = null, toDate = null) => {
    try {
      const params = new URLSearchParams();

      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);

      const response = await axios.get(
        `${BASE_URL}/holidays?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all employees
  getAllEmployees: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/get-all-employee`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Request leave cancellation (for employee)
  requestCancellation: async (leaveId, data) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/leave/${leaveId}/request-cancellation`,
        data
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all leave cancellation requests (for admin/HR)
  getAllCancellationRequests: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      });

      const response = await axios.get(
        `${BASE_URL}/leave/admin/cancellation-requests?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Decide on leave cancellation request (for admin) approve or reject
  decideCancellation: async (leaveId, payload) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/leave/admin/${leaveId}/decide-cancellation`,
        payload
      );

      return response.data;

    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get archived leave cancellation requests (for admin/HR)
  getArchivedCancellationRequests: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      });

      const response = await axios.get(
        `${BASE_URL}/leave/admin/cancellation-archived?${params.toString()}`
      );

      return response.data;

    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

};

